import { render, staticRenderFns } from "./QTabPane.vue?vue&type=template&id=1b313386&"
import script from "./QTabPane.vue?vue&type=script&lang=js&"
export * from "./QTabPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports